import React, { useState } from "react";
import { useParams, useHistory, generatePath } from "react-router-dom";
import ROUTES from "config/routing";

// import useDesignManagement from "../../pageV2/useDesignManagement";
// import Breadcrumbs from "../header/Breadcrumbs";
// import TemplatesList from "./TemplatesList";
// import TemplatesHeader from "./TemplatesHeader";
// import Title from "../header/Title";

const TemplatesPage = () => {
  const { campaignId, clientId, countryCode, roomId } = useParams();
  const history = useHistory();

  const createFromScratch = async () => {
    let path = "";
    if (campaignId && clientId) {
      path = generatePath(ROUTES.FLYER_BUILDER, { campaignId, clientId, format: "TEARAWAY" });
    } else if (countryCode && roomId) {
      path = generatePath(ROUTES.PUBLIC_FLYER_BUILDER, { countryCode, roomId, format: "TEARAWAY" });
    }
    // make sure to pass current search query to the path on redirect
    const currentParams = new URLSearchParams(window.location.search);
    const searchParams = currentParams.toString();
    if (searchParams) {
      path = `${path}?${searchParams}`;
    }
    history.push(path);
  };

  return createFromScratch();
  // TODO: ENABLE TEMPLATES AFTER ADMIN SIDE IS DONE
  //
  // const { publicTemplates } = useDesignManagement({ clientId: clientId || "" });
  // const [selectedIndustry, setSelectedIndustry] = useState("All");
  // const [selectedFlyerFormat, setSelectedFlyerFormat] = useState("All");
  // const [selectedOrientation, setSelectedOrientation] = useState("All");
  // const [searchQuery, setSearchQuery] = useState("");
  // const [isUSPSCompliant, setIsUSPSCompliant] = useState(false);

  // const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  //   setSearchQuery(event.target.value);
  // };

  // const filteredTemplates = publicTemplates.filter((template) => {
  //   if (selectedIndustry && selectedIndustry !== "All") {
  //     return template.industry?.toLowerCase().includes(selectedIndustry.toLowerCase());
  //   }
  //   if (selectedFlyerFormat && selectedFlyerFormat !== "All") {
  //     return template.format?.toLowerCase().includes(selectedFlyerFormat.toLowerCase());
  //   }
  //   if (selectedOrientation && selectedOrientation !== "All") {
  //     return template.orientation?.toLowerCase().includes(selectedOrientation.toLowerCase());
  //   }
  //   if (searchQuery) {
  //     return template.name.toLowerCase().includes(searchQuery.toLowerCase());
  //   }
  //   if (isUSPSCompliant) {
  //     return template.uspsCompliant;
  //   }
  //   return true;
  // });

  // return (
  //   <div className="flex flex-col gap-4 bg-[#f9fafb] p-10">
  //     <Breadcrumbs />
  //     <Title titleText="Select templates" />
  //     <div className="flex gap-10 flex-col">
  //       <TemplatesHeader
  //         selectedIndustry={selectedIndustry}
  //         setSelectedIndustry={setSelectedIndustry}
  //         selectedFlyerFormat={selectedFlyerFormat}
  //         setSelectedFlyerFormat={setSelectedFlyerFormat}
  //         selectedOrientation={selectedOrientation}
  //         setSelectedOrientation={setSelectedOrientation}
  //         searchQuery={searchQuery}
  //         handleSearchChange={handleSearchChange}
  //         isUSPSCompliant={isUSPSCompliant}
  //         setIsUSPSCompliant={setIsUSPSCompliant}
  //       />
  //       <TemplatesList createFromScratch={createFromScratch} templates={filteredTemplates} />
  //     </div>
  //   </div>
  // );
};

export default TemplatesPage;
